// #region imports

// --- Angular
import { Route } from '@angular/router';

// --- HS Code
import * as c from './';
import { authGuard, participantGuard, respondentGuard, userDetailsGuard } from './core/guards';

// #endregion

export const routes: Route[] = [
  { path: '', pathMatch: 'full', loadChildren: () => import('./home/home.module').then(mod => mod.HomeModule) },
  { path: 'dashboard', canActivate: [authGuard], loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule) },
  { path: 'endpoints', loadChildren: () => import('./endpoints/endpoints.module').then(mod => mod.EndpointsModule) },
  { path: 'journal', canActivate: [authGuard, participantGuard], loadChildren: () => import('./my-rhythms/my-rhythms.module').then(mod => mod.MyRhythmsModule) },
  { path: 'login', loadChildren: () => import('./home/home.module').then(mod => mod.HomeModule ) },
  { path: 'mydevelopment/:context/:id', canActivate: [authGuard, participantGuard], loadChildren: () => import('./my-development/my-development.module').then(mod => mod.MyDevelopmentModule) },
  { path: 'profile', canActivate: [authGuard, participantGuard], loadChildren: () => import('./profile/profile.module').then(mod => mod.ProfileModule) },
  { path: 'reports/:id', canActivate: [authGuard, participantGuard], loadChildren: () => import('./reports/reports.module').then(mod => mod.ReportsModule) },
  { path: 'respondent', canActivate: [authGuard, respondentGuard], loadChildren: () => import('./respondent/respondent.module').then(mod => mod.RespondentModule) },
  { path: 'signout-callback', component: c.SignoutRedirectCallbackComponent },
  { path: 'surveys', canActivate: [authGuard], loadChildren: () => import('./survey/survey.module').then(mod => mod.SurveyModule) },
  { path: 'user-details', canActivate: [authGuard, userDetailsGuard], loadChildren: () => import('./user-details/user-details.module').then(mod => mod.UserDetailsModule) },

  // Error paths
  { path: 'error', component: c.ErrorComponent, pathMatch: 'full' },
  { path: 'error/test', component: c.ErrorTestComponent, pathMatch: 'full' },
  { path: '**', component: c.ErrorNotfoundComponent, pathMatch: 'full' }
];
